<template>
	<div id="app" :aria-busy="loading ? 'true' : 'false'">
		<div v-if="!loading" :class="'main-container '+ this.organizationTheme">
			<input type="checkbox" id="menu-controller" class="menu-controller" hidden>
			<headerBar v-if="this.$route.meta.requiresAuth"></headerBar>
			<div class="content" :class="this.$route.name" v-cloak>
				<sidebar v-if="this.$route.meta.requiresAuth" :route="this.$route.name"></sidebar>
				<div class="content__container" v-if="this.$route.meta.requiresAuth">
					<div class="content__wrapper">
						<router-view></router-view>
					</div>
					<m-footer></m-footer>
				</div>
				<div v-if="!this.$route.meta.requiresAuth" class="login-screen">
					<router-view></router-view>
				</div>
			</div>
		</div>
		<div
				v-if="user && user.fb_page_id"
				class="fb-customerchat"
				attribution=setup_tool
				:page_id="user.fb_page_id"
				theme_color="#00ceb9"
				logged_in_greeting="Olá! Como posso ajudar?"
				logged_out_greeting="Olá! Como posso ajudar?"
		>
		</div>
	</div>
</template>

<script>
import 'intro.js/introjs.css';
import modulesConfigs from './modules/config';
import headerBar from './components/header.vue';
import sidebar from './components/sidebar.vue';
import mFooter from './components/m-footer.vue';

const demo = require('./vendor.js');

// Sentry.init({
// 	dsn: 'https://0f262bd0673b4039845a5c2a1089dc27@sentry.eokoe.com/10',
// 	maxBreadcrumbs: 50,
// 	integrations: [new Sentry.Integrations.Vue({ Vue })],
// });

export default {
	name: 'app',
	components: {
		headerBar,
		sidebar,
		mFooter,
	},
	data() {
		return {
			loading: false,
		};
	},
	computed: {
		user() {
			return this.$store.state.user;
		},
		userModules() {
			const organizations = sessionStorage.getItem('organizations');
			const apiModules = JSON.parse(organizations)[0].modules;

			const userModules = apiModules.map((x) => {
				const [userModule] = this.allConfigs.filter(y => y.name === x.name);
				return Object.assign(x, userModule);
			});

			return userModules;
		},
		userRouter() {
			const router = this.userModules.map((item) => {
				const routerItem = item.routes;
				return routerItem;
			});
			return router.filter(x => x);
		},
		// userMenu() {
		// 	const menu = this.userModules.map((item) => {
		// 		const menuItem = item.menu;
		// 		menuItem.name = item.name;
		// 		return menuItem;
		// 	});
		// 	let groupedMenu = {};
		// 	let sortedMenu = [];

		// 	function groupBy(objectArray) {
		// 		return objectArray.reduce((acc, obj) => {
		// 			const key = obj.parent;
		// 			if (!acc[key]) {
		// 				acc[key] = [];
		// 			}
		// 			acc[key].push(obj);
		// 			return acc;
		// 		}, {});
		// 	}

		// 	groupedMenu = groupBy(menu);

		// 	sortedMenu = this.menuOrder.map(x => ({
		// 		parent: x,
		// 		children: groupedMenu[x],
		// 	})).filter(x => x);
		// 	return sortedMenu;
		// },
		allConfigs() {
			return modulesConfigs.modulesConfigs;
		},
		organizationTheme() {
			if (this.$route.meta.requiresAuth) {
				if (this.$store.state.user.organization.is_mandatoaberto === 1) {
					return 'theme-mandato';
				} else if (this.$store.state.user === undefined) {
					return 'theme-default';
				}
				return 'theme-default';
			}
			return '';
		},
		success() {
			return this.$store.state.status;
		},
		statusError() {
			return this.$store.state.statusError;
		},
	},
	beforeUpdate() {
		this.$intro().exit();
	},
	methods: {
		checkStatus() {
			this.$nextTick(() => {
				const status = parseInt(sessionStorage.getItem('statusCode'), 10);
				if (status == 403) {
					this.$store.dispatch('signOut');
					this.$router.push('/');
				}
			});
		},
		setUserModules() {
			const organizations = sessionStorage.getItem('organizations');
			const apiModules = JSON.parse(organizations)[0].modules;

			const userModules = apiModules.map((x) => {
				const [userModule] = this.allConfigs.filter(y => y.name === x.name);
				return Object.assign(x, userModule);
			});

			// import('./Foo.vue').then

			// loop userModules {
			// import dinamico
			//	quando estiver pronto
			//		this.$store.commit('setModules', userModule);
			// 			this.setUserRoutes(userModule.route);
			// }


			// console.log('userModules', userModules);
			this.$store.commit('setModules', userModules);
			this.setUserRoutes(userModules);
		},
		setUserRoutes(userModules) {
			const routes = userModules.map(item => item.routes).filter(x => x);
			// console.log('addRoutes', routes);
			this.$router.addRoutes(routes);
		},
		// userMenu() {
		// 	const menu = this.userModules.map((item) => {
		// 		const menuItem = item.menu;
		// 		menuItem.name = item.name;
		// 		return menuItem;
		// 	});
		// 	let groupedMenu = {};
		// 	let sortedMenu = [];

		// 	function groupBy(objectArray) {
		// 		return objectArray.reduce((acc, obj) => {
		// 			const key = obj.parent;
		// 			if (!acc[key]) {
		// 				acc[key] = [];
		// 			}
		// 			acc[key].push(obj);
		// 			return acc;
		// 		}, {});
		// 	}

		// 	groupedMenu = groupBy(menu);

		// 	sortedMenu = this.menuOrder.map(x => ({
		// 		parent: x,
		// 		children: groupedMenu[x],
		// 	})).filter(x => x);
		// 	return sortedMenu;
		// },
	},
	updated() {
		this.checkStatus();
	},
	mounted() {
		document.querySelector('html').classList.add(process.env.THEME);
		this.checkStatus();
		if (this.$route.meta.requiresAuth === true) {
			if (parseInt(sessionStorage.getItem('statusCode'), 10) === 403) {
				this.$store.dispatch('signOut');
				this.$router.push('/');
			} else {
				const session = {
					apiKey: sessionStorage.getItem('apiKey'),
					userId: sessionStorage.getItem('userId'),
				};
				this.loading = true;
				this.$store.dispatch('loadUser', session)
					.then(() => {
						this.loading = false;
						this.$store.dispatch('getNotifications', session)
							.then(() => {
								this.setUserModules();
								this.loading = false;
							})
							.catch(() => {
								this.loading = false;
							});
					})
					.catch(() => {
						this.loading = false;
					});
			}
		}
	},
};
</script>
<style>
	.introjs-helperNumberLayer {
		right: -16px !important;
		left: initial;
	}

</style>



// WEBPACK FOOTER //
// _source/javascripts/App.vue